// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge-module__badge--15xcC","multidigit":"Badge-module__multidigit--rdH1A","wrapper":"Badge-module__wrapper--2tyvI"};